import React from 'react'
import ListPage from '../../components/ListPage'
export default function Rules() {
 
    const ListContent=[
                "Identity card should be shown at the checkpoint.",
                "Leave your bags, handbags and personal belongings at the depository/property counter.",
                "No person shall write on, damage or make any mark on any book, journal or other material belonging to the library.",
                "Books should be handled with great care and damage of books in any manner will be heavily fined.",
                "Students can borrow four books at a time.",
                "Students can retain the books for two weeks only, after which a fine of Rs.1/- Per book per day will be charged.",
                "Renewals are allowed only when there is no claim by others. No phone renewal will be entertained.",
                "A borrowed book if recalled by the Librarian must be returned immediately.",
                "Online reservation can be done for a book, which is already lent out. Reserved books are kept separately in circulation counter for two days for each member.",
                "Maintain a Queue at the circulation counter.",
                "Wearing ID-Card is compulsory.",
                "Usage of mobile phone is prohibited.",
                "Eatables not allowed inside the library."
        ]
  return (
    <div>
       <ListPage
       Title='Rules and Regulations'
       ListContent={ListContent}
       shouldWrap={false}
       />
          </div>
  )
}
